<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['command.id']" placeholder="placeholder.commandId" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query['commandStatus']" :options="commandStatus" placeholder="placeholder.commandStatus" @change="refresh"/>
        <vxe-input v-model="query['order.no']" placeholder="placeholder.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.no']" placeholder="placeholder.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['barcode.no']" placeholder="placeholder.replenishmentBarcode" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-date-range-picker v-model="query.range" linked-panels placeholder="business.label.addTime" type="date" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.expConfirm" icon="vxe-icon-upload" status="info" @click="exp"/>
      </template>
      <vxe-table ref="table" :data="data" :export-config="{}" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="command.addTime" sortable title="business.label.addTime" width="170"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:commandStatus}" field="command.commandStatus" title="business.label.commandStatus" width="100"/>
        <vxe-column field="order.no" sortable title="business.label.orderNo" width="120"/>
        <vxe-column field="barcode.no" sortable title="business.label.barcode" width="100"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="120"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="120"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="120"/>
        <vxe-column field="lot.no" title="business.label.lotNo" width="100"/>
        <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="workstation.name" title="business.label.workstation" width="100"/>
        <vxe-column field="pickingOrder.no" title="business.label.pickingOrderNo" width="140"/>
        <vxe-column field="command.quantity" title="business.label.quantity" width="80"/>
        <vxe-column field="sourceLocation.no" title="business.label.sourceLocation" width="100"/>
        <vxe-column field="sourceZone.name" title="business.label.sourceZone" width="100"/>
        <vxe-column field="sourceStorageRoom.name" title="business.label.sourceStorageRoom" width="100"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.sourceActivated" title="business.label.sourceActivated" width="60"/>
        <vxe-column field="removing.operator" title="business.label.remover" width="60"/>
        <vxe-column field="removing.startTime" sortable title="business.label.removingStartTime" width="170"/>
        <vxe-column field="removing.finishTime" sortable title="business.label.removingFinishTime" width="170"/>
        <vxe-column field="targetLocation.no" title="business.label.targetLocation" width="100"/>
        <vxe-column field="targetZone.name" title="business.label.targetZone" width="100"/>
        <vxe-column field="targetStorageRoom.name" title="business.label.targetStorageRoom" width="100"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.targetActivated" title="business.label.targetActivated" width="60"/>
        <vxe-column field="shelving.operator" title="business.label.shelver" width="60"/>
        <vxe-column field="shelving.startTime" sortable title="business.label.shelvingStartTime" width="170"/>
        <vxe-column field="shelving.finishTime" sortable title="business.label.shelvingFinishTime" width="170"/>
        <vxe-column field="command.id" title="business.label.commandId" width="180"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import moment from 'moment'
import { getEnums } from '@/utils/util'

export default {
  name: 'ReplenishCommandQuery',
  data() {
    return {
      loading: false,
      data: [],
      query: {
        'command.id': '',
        commandStatus: undefined,
        'order.no': '',
        'item.no': '',
        'barcode.no': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      },
      commandStatus: [],
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  created() {
    getEnums('CommandStatus').then(result => {
      this.commandStatus = result
    })
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.range.length > 0) {
        args['dateRange'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['dateRange'] = null
      }
      findAll('replenishmentCommandFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'command.id': '',
        commandStatus: undefined,
        'order.no': '',
        'item.no': '',
        'barcode.no': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
      this.refresh()
    },
    exp() {
      this.$refs.table.openExport()
    }
  }
}
</script>